export default __webpack_public_path__ + "static/media/sello120x120.71aa23ca.WebP";